import gql from 'graphql-tag';

export const createOT = gql`
    mutation insertOT($orden: String, $clave: String, $colada: String, $modelo: ModeloInput, $disp: String, $dispUUID: String $inicio: Float, $fin: Float, $estado: String,$bono: String) {
    insertOT(orden: $orden, clave: $clave, colada: $colada, modelo: $modelo, disp: $disp, dispUUID: $dispUUID inicio: $inicio, fin: $fin, estado: $estado, bono: $bono) 
}`
